import React, { useEffect, useState } from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { getReconciliationHistory } from "services/reportsService";

interface ReconciliationHistoryModalProps {
  open: boolean;
  onClose: () => void;
  betTxnId: string;
}

export default function ReconciliationHistoryModal({
  open,
  onClose,
  betTxnId,
}: ReconciliationHistoryModalProps) {
  const [logs, setLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && betTxnId) {
      setLoading(true);
      setLogs([]);
      getReconciliationHistory(betTxnId)
        .then((resp) => setLogs(resp?.data ?? []))
        .catch(() => setLogs([]))
        .finally(() => setLoading(false));
    }
  }, [open, betTxnId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        Reconciliation History
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : logs.length === 0 ? (
          <Typography color="text.secondary" sx={{ py: 2 }}>
            No reconciliation history found for this bet.
          </Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Timestamp</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Method</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Resolved As</TableCell>
                <TableCell>Status Before</TableCell>
                <TableCell>Status After</TableCell>
                <TableCell>Performed By</TableCell>
                <TableCell>Result</TableCell>
                <TableCell>Error</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.map((log: any, idx: number) => (
                <TableRow key={log._id ?? idx}>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    {new Date(log.timestamp).toLocaleString()}
                  </TableCell>
                  <TableCell>{log.action}</TableCell>
                  <TableCell>{log.method}</TableCell>
                  <TableCell>
                    {log.amount} {log.currency}
                  </TableCell>
                  <TableCell>{log.resolvedAs ?? "-"}</TableCell>
                  <TableCell>{log.roundStatusBefore}</TableCell>
                  <TableCell>{log.roundStatusAfter}</TableCell>
                  <TableCell>{log.performedByEmail}</TableCell>
                  <TableCell>
                    <Chip
                      label={log.result}
                      color={log.result === "SUCCESS" ? "success" : "error"}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    {log.errorDetails?.message ?? "-"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
    </Dialog>
  );
}
